<template>
  <v-container fluid>
    <material-card
      :heading="heading"
      icon-small
      icon="mdi-clipboard-list-outline"
      :title="heading"
      color="primary"
    >
      <v-card-text>
        <!-- pc view -->
        <v-data-table
          :headers="getHeaders()"
          :items="meetings"
          :loading="loading"
          :options="options"
          loading-text="Loading... Please wait"
        >
          <!-- <template
            slot="items"
            slot-scope="props"
          >
            <td>
              {{ props.item.startDtime }}
            </td>
            <td>
              {{ props.item.endDtime }}
            </td>
            <td>
              <v-icon
                small
                :color="'green'"
              >
                mdi-door-open
              </v-icon>
              {{ props.item.roomIds.length > 0 ? props.item.roomIds[0].typeName : '-' }}
            </td>
            <td>
              {{ props.item.roomIds.length > 1 ? `${props.item.roomIds[0].name} +${props.item.roomIds.length - 1} others`
                : props.item.roomIds.length > 0 ? props.item.roomIds[0].name : '' }}
            </td>
            <td>
              {{ props.item.creator.displayFullName ? props.item.creator.displayFullName : props.item.creator.username }}
            </td>
            <td>
              {{ props.item.title }}
            </td>
            <td class="text-center">
              <v-icon
                v-if="props.item.repeatInfo.freq !== null && props.item.repeatInfo.freq !== undefined"
                small
                color="primary"
              >
                refresh
              </v-icon>
              {{
                props.item.repeatInfo.freq !== null && props.item.repeatInfo.freq !== undefined
                  ? (props.item.repeatInfo.freq === 'WEEKLY'
                    ? ('Weekly' + (props.item.repeatInfo.byInterval ? '(' + props.item.repeatInfo.byInterval + ')' : '' ) )
                    : 'Daily' )
                  : '-'
              }}
            </td>
            <td class="text-center">
              <v-icon
                v-if="props.item.repeatInfo.freq !== null && props.item.repeatInfo.freq !== undefined"
                small
                color="primary"
              >
                refresh
              </v-icon>
              {{ props.item.repeatInfo.freq !== null && props.item.repeatInfo.freq !== undefined ? props.item.repeatInfo.freq : '-' }}
            </td>
          </template> -->
          <template v-slot:item.statusText="{ item }">
            <v-sheet
              dark
              label
              small
              :color="getColorByStatus(item.status)"
              text-color="white"
              style="maring-right:0px; maring-left:0px; padding-right:0px; padding-left:0px;min-width: 90px; max-width: 90px; height: 25px; padding-top: 2px;"
            >
              {{ item.statusText }}
            </v-sheet>
          </template>
          <template v-slot:item.detail="{ item }">
            <v-btn
              icon
              @click="detailMeeting(item)"
            >
              <v-icon
                color="info"
              >
                mdi-information
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
              color="green"
              @click="editMeeting(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              color="error"
              @click="cancelMeeting(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </material-card>
    <v-btn
      v-if="$vuetify.breakpoint.mdAndUp"
      depressed
      absolute
      bottom
      right
      dark
      large
      class="primary v-btn--example mb-5 mr-2"
      @click="$router.push('/reservation/')"
    >
      <v-icon>
        mdi-plus
      </v-icon>
      {{ $t('meeting.reserve') }}
    </v-btn>
    <v-btn
      v-else
      fab
      large
      dark
      absolute
      bottom
      right
      color="primary"
      class="v-btn--example mb-15"
      @click="$router.push('/reservation/')"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <confirm-dialog
      :title="confirm.title"
      :content="confirm.content"
      :dialog="confirm.dialog"
      :to-parent="confirmDialogClose"
    />

    <custom-dialog
      :title="confirm.title"
      :dialog="confirm.dialog"
      :to-parent="confirmDialogClose"
    >
      <div slot="content">
        test 입니다
      </div>
    </custom-dialog>
  </v-container>
</template>
<script>
  import { get } from 'vuex-pathify'
  import * as helpers from '@/util/helpers'

  export default {

    data: () => ({
      heading: '',
      meetings: [],
      todayMeetings: [],
      loading: false,
      options: {
        sortDesc: true,
        page: 1,
        itemsPerPage: 10,
      },
      confirm: {
        title: '',
        content: '',
        dialog: false,
      },
      selectedMeeting: null,
    }),

    computed: {
      info: get('user/info'),
    },

    created () {
      this.heading = this.$t('page.meeting-list')
    },

    mounted () {
      this.getMeeting()
    },

    methods: {
      getHeaders () {
        return [
          { text: this.$t('meeting.sta-time'), value: 'startDtime', width: '150px !important', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.end-time'), value: 'endDtime', width: '150px !important', align: 'center', sortable: false, class: 'primary--text' },
          // { text: this.$t('meeting.type'), value: 'isImmediately', width: '30px !important', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.type'), value: 'roomIds[0].typeName', width: '200px !important', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.meeting-room'), value: 'roomIds[0].name', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.creator'), value: 'creator.username', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.title'), value: 'title', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.status'), value: 'statusText', width: '100px', align: 'center', sortable: false, class: 'primary--text' },
          { text: this.$t('meeting.detail'), value: 'detail', align: 'center', width: '100px', sortable: false, class: 'primary--text' },
          // { text: this.$t('meeting.repeat'), align: 'center', width: '110px', sortable: false, class: 'primary--text' },
          // { text: this.$t('meeting.control'), align: 'center', width: '70px', sortable: false, class: 'primary--text' },
          { text: '수정 / 삭제', value: 'actions', style: 'color: black;', align: 'center', width: '120px', sortable: false, class: 'primary--text' },
          // { text: this.$t('meeting.skype'), style: 'color: black;', align: 'center', width: '80px', sortable: false, class: 'primary--text' }

          // { text: this.$t('meeting.meeting-name'), value: 'title', align: 'center', sortable: false },
          // { text: this.$t('meeting.meeting-sta-time'), value: 'startDtime', align: 'center', sortable: false, },
          // { text: this.$t('meeting.meeting-end-time'), value: 'endDtime', align: 'center', sortable: false },
          // { text: this.$t('meeting.creator'), value: 'creator', align: 'center', sortable: false },
          // { text: this.$t('meeting.meeting-type'), value: 'type', align: 'center', sortable: false },
          // { text: this.$t('meeting.repeat'), value: 'repeat', align: 'center', sortable: false },
          // { text: this.$t('meeting.status'), value: 'status', align: 'center', sortable: false },
          // { text: this.$t('meeting.detail'), align: 'center', width: '50px', sortable: false },
          // { text: this.$t('meeting.delete'), align: 'center', width: '125px', sortable: false }
        ]
      },
      async getMeeting () {
        await this.$http.get(`/api/v1/meetings/email/${this.info.email}`).then(response => {
          this.meetings = response.data

          this.meetings = [
            {
              id: 1,
              startDtime: '2021-05-06 12:00',
              endDtime: '2021-05-06 16:00',
              status: 'r',
              statusText: '예약',
              creator: {
                username: '김태민',
                displayFullName: '김태민',
                email: 'tmkim@ecstel.co.kr',
              },
              roomIds: [
                {
                  name: '회의실1',
                  typeName: '1층',
                  buildingName: '본사',
                },
              ],
              title: '테스트',
            },
            {
              id: 2,
              startDtime: '2021-05-06 12:00',
              endDtime: '2021-05-06 16:00',
              status: 'r',
              statusText: '예약',
              creator: {
                username: '김태민',
                displayFullName: '김태민',
                email: 'tmkim@ecstel.co.kr',
              },
              roomIds: [
                {
                  name: '회의실1',
                  typeName: '1층',
                  buildingName: '본사',
                },
              ],
              title: '테스트',
            },
          ]
          this.todayMeetings = this.meetings
        }).catch(err => {
          console.log(err)
        })
      },
      detailMeeting (meeting) {
        console.log(meeting)
      },
      async editMeeting (meeting) {
        console.log(meeting)
      },
      async cancelMeeting (meeting) {
        this.selectedMeeting = meeting
        this.confirm.dialog = true
        this.confirm.title = '회의 취소'
        this.confirm.content = '회의를 취소하시겠습니까?'
      },
      getColorByStatus (status) {
        return helpers.getColorByStatus(status)
      },
      confirmDialogClose (result) {
        if (result === 'ok') {
        } else {
        }
        this.confirm.dialog = false
      },
    },
  }
</script>

<style scoped>

</style>
